<script setup lang="ts">
// Simplified hero section—no animation logic needed for centered layout
</script>

<template>
  <section
    id="home"
    class="home-hero text-white overflow-hidden"
  >
    <div class="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 py-20">
      <div class="max-w-3xl w-full text-center space-y-8">
        <!-- Eyebrow -->
        <p class="text-sm font-semibold tracking-[0.1em] uppercase text-spruce-100">
          Governed AI operations for GMP quality teams
        </p>

        <!-- Main headline -->
        <h1 class="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-tight">
          Deploy GMP-ready AI agents with Quality Compliance by Design
        </h1>

        <!-- Supporting copy -->
        <p class="text-xl sm:text-2xl text-white/80 leading-relaxed max-w-2xl mx-auto">
          Design, govern, and operate regulated AI workflows on one platform, with controls built for strict compliance environments to ensure patient safety.
        </p>

        <!-- Single primary CTA -->
        <div class="pt-8">
          <UButton
            to="/contact/"
            size="xl"
            class="!bg-white !text-spruce-800 hover:!bg-neutral-50 font-semibold px-8 py-4 text-lg rounded-full"
          >
            Modernise GMP Quality Workflows
          </UButton>
        </div>

        <!-- Proof signals -->
        <div class="pt-12 grid gap-4 sm:grid-cols-3 max-w-2xl mx-auto text-sm">
          <div class="text-white/70">
            <p class="mb-1 font-semibold text-white">
              GMP Production Ready
            </p>
            <p>
              Automated, tested and validated deployments
            </p>
          </div>
          <div class="text-white/70">
            <p class="mb-1 font-semibold text-white">
              Compliance by Design
            </p>
            <p>
              Follow industry leading good practices
            </p>
          </div>
          <div class="text-white/70">
            <p class="mb-1 font-semibold text-white">
              Audit Ready
            </p>
            <p>
              Every decision documented
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.home-hero {
  background: linear-gradient(135deg, #22452E 0%, #2d5a3d 25%, #1a3428 50%, #2d5a3d 75%, #22452E 100%);
  position: relative;
}

.home-hero::before {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 120px;
  background: radial-gradient(ellipse 800px 120px at 50% 100%, rgba(255, 255, 255, 0.08) 0%, transparent 70%);
  pointer-events: none;
}
</style>
